###
  Неймспейсы!
###

# Global ns
window.getintent = {} unless window.getintent?
window.getintent.utils = {} if window.getintent.utils == undefined

window.INTENT =
  widgets: {}
  utils: {}
  templates: {}
  helpers: {}
  report: {}